/* eslint-disable unicorn/filename-case */
/**
 * A promise wrapper that can be resolved or rejected at a later point in time
 *
 * Based on jQuery Deferred: https://api.jquery.com/category/deferred-object/
 */
export class Deferred {
    /**
     * Resolves the promise with given value.
     */
    resolve;
    /**
     * Reject the promise with given reason.
     */
    reject;
    _promise;
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        Object.freeze(this);
    }
    /**
     * Get the underlying promise that can be awaited.
     */
    get promise() {
        return this._promise;
    }
}
//# sourceMappingURL=Deferred.js.map